import React from 'react';

interface ReportContentWrapperProps {
  link?: string | any[];
  onComponentDidMount: (...args: any[]) => any;
}

class ReportContentWrapper extends React.Component<ReportContentWrapperProps, {}> {
  componentDidMount() {
    const { link } = this.props;
    this.props.onComponentDidMount(link);
  }

  render() {
    const { children } = this.props;

    return <div>{children}</div>;
  }
}

export default ReportContentWrapper;
